import { hasSubscription as hasLegacySubscription } from '../internal/legacySubscription/hasSubscription';
import { hasSubscription as hasModernSubscription } from '../internal/modernSubscription/hasSubscription';
import type { Subscription } from '../types';

import { isModernSubscription } from './isModernSubscription';

export function hasSubscription(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return hasModernSubscription(subscription);
  }

  return hasLegacySubscription(subscription);
}
